import { render, staticRenderFns } from "./ReceivedHistory.vue?vue&type=template&id=dd3f9554&scoped=true&"
import script from "./ReceivedHistory.vue?vue&type=script&lang=js&"
export * from "./ReceivedHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3f9554",
  null
  
)

export default component.exports